export type TooltipPosition = 'top' | 'bottom' | 'left' | 'right';

export interface TooltipProps {
  /** Position of the tooltip relative to the trigger element */
  position?: TooltipPosition;
  /** Delay in milliseconds before showing the tooltip */
  delayDuration?: number;
  /** If disabled, the tooltip won't open. The trigger is always rendered. */
  disabled?: boolean;
}

export const horizontalToVerticalPosition: Record<string, TooltipPosition> = {
  right: 'bottom',
  left: 'top',
};
